// Given a set of data points, do linear piecewise interpolation
import * as _ from "underscore";

// envelope is an ordered list of t, w coordinates
//
// returns the w value for the given t
export const getWord = (envelope, t) => {
  if (t <= envelope[0].t || envelope.length === 1) {
    return envelope[0].w;
  }

  const lastIndex = envelope.length - 1;
  if (t >= envelope[lastIndex].t) {
    return envelope[lastIndex].w;
  }

  let index = 1;
  while (t > envelope[index].t) {
    index++;
  }

  const t1 = envelope[index - 1].t;
  const w1 = envelope[index - 1].w;
  const t2 = envelope[index].t;
  const w2 = envelope[index].w;

  return (w1 * (t2 - t) + w2 * (t - t1)) / (t2 - t1);
};

export const getTime = (envelope, w) => {
  const inverseEnvelope = _.map(envelope, (point) => ({
    t: point.w,
    w: point.t,
  }));

  return getWord(inverseEnvelope, w);
};

// Adds a point to the envelope, adjusting the surrounding points to remove conflicts,
// returns a list of removed points
export const addPoint = (envelope, point) => {
  const removedPoints = [];
  let sortedIndex = _.sortedIndex(_.pluck(envelope, "t"), point.t);

  while (sortedIndex > 0 && envelope[sortedIndex - 1].w >= point.w) {
    sortedIndex--;
    removedPoints.push(envelope.splice(sortedIndex, 1)[0]);
  }
  while (sortedIndex < envelope.length && envelope[sortedIndex].w <= point.w) {
    removedPoints.push(envelope.splice(sortedIndex, 1)[0]);
  }

  envelope.splice(sortedIndex, 0, point);

  return removedPoints;
};
